// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, FileText, Mail, Heart } from 'lucide-react';

const Footer = ({ variant = 'default' }) => {
  const isMinimal = variant === 'minimal';
  
  return (
    <footer className={`mt-8 ${isMinimal ? 'py-4' : 'py-8'}`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className={`bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border-2 border-gray-200 ${isMinimal ? 'p-4' : 'p-6'}`}>
          {!isMinimal && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              {/* About Section */}
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                    <Heart className="w-4 h-4 text-white" />
                  </div>
                  <h3 className="font-bold text-gray-800">TheOliveTree</h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Making Arabic learning fun and accessible for children worldwide. 
                  Safe, educational, and designed with love. 🌟
                </p>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="font-bold text-gray-800 mb-3">Quick Links</h3>
                <div className="space-y-2">
                  <Link 
                    to="/" 
                    className="block text-gray-600 hover:text-purple-600 text-sm transition-colors"
                  >
                    🎮 Games
                  </Link>
                  <Link 
                    to="/chat" 
                    className="block text-gray-600 hover:text-purple-600 text-sm transition-colors"
                  >
                    💬 AI Chat
                  </Link>
                  <Link 
                    to="/dashboard" 
                    className="block text-gray-600 hover:text-purple-600 text-sm transition-colors"
                  >
                    📊 Dashboard
                  </Link>
                </div>
              </div>

              {/* Contact */}
              <div>
                <h3 className="font-bold text-gray-800 mb-3">Contact Us</h3>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Mail className="w-4 h-4" />
                    <span>admin@my-roots.ca</span>
                  </div>
                  <p className="text-gray-600 text-sm">
                    We'd love to hear from you! 😊
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Policy Links & Copyright */}
          <div className={`${isMinimal ? '' : 'border-t border-gray-200 pt-6'} flex flex-col md:flex-row items-center justify-between gap-4`}>
            <div className="flex flex-wrap items-center gap-4 justify-center md:justify-start">
              <Link
                to="/privacy-policy"
                className="flex items-center gap-2 text-gray-600 hover:text-purple-600 font-medium text-sm transition-colors"
              >
                <Shield className="w-4 h-4" />
                Privacy Policy
              </Link>
              <span className="text-gray-300">•</span>
              <Link
                to="/terms-of-service"
                className="flex items-center gap-2 text-gray-600 hover:text-purple-600 font-medium text-sm transition-colors"
              >
                <FileText className="w-4 h-4" />
                Terms of Service
              </Link>
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-gray-500 text-sm">
                © 2021-2025 | My Roots | All Rights Reserved | Made with ❤️ for families.
              </p>
              <p className="text-gray-400 text-xs mt-1">
                COPPA & GDPR Compliant • Child-Safe Learning
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;